import { render, staticRenderFns } from "./ProductCyclopediaCategoriesEditorCard.vue?vue&type=template&id=4a744f15&scoped=true&"
import script from "./ProductCyclopediaCategoriesEditorCard.vue?vue&type=script&lang=js&"
export * from "./ProductCyclopediaCategoriesEditorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a744f15",
  null
  
)

export default component.exports